import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import ReduAsync from 'redu-async';

import { WindowProxy } from '@sm360/widget-commons-core-services';
import { isObject } from 'lodash';

class ReduxClient {
    _create() {
        // Add tracing: WindowProxy.get().__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })
        const composeEnhancers = WindowProxy.get().__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        this.store = createStore((state) => state, composeEnhancers(applyMiddleware(thunk)));

        return this.store;
    }

    /**
     * Initialize a redux store or return it if it's aleady initialized
     * @returns {ReduxStore}
     */
    getOrCreate() {
        return this.store || this._create();
    }

    /**
     * Add multiple reducers at once
     * @param {Object} reducers Reducers object with the format { reducerName: reducer }
     */
    addReducers(reducers) {
        if (!this.store || !reducers || !isObject(reducers)) {
            return;
        }

        ReduAsync.addReducers(this.store, reducers);
    }
}

export default new ReduxClient();
